var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("add-to-calendar-button", {
    attrs: {
      name: _vm.calendarEventData.name,
      description: _vm.calendarEventData.description,
      startDate: _vm.calendarEventData.startDate,
      startTime: _vm.calendarEventData.startTime,
      endDate: _vm.calendarEventData.endDate,
      endTime: _vm.calendarEventData.endTime,
      timeZone: _vm.calendarEventData.timeZone,
      location: _vm.calendarEventData.location,
      options: "'Apple','Google','iCal','Outlook.com','Yahoo'",
      buttonStyle: "custom",
      customCss: _vm.stylesUrl,
      buttonsList: "",
      hideIconButton: "",
      hideBackground: "",
      size: "5",
      lightMode: "bodyScheme",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }